if (!customElements.get('spec-table')) {
  class SpecTable extends HTMLElement {
    constructor() {
      super();
      this.specs = window.specTable;
      this.tableWrap = this.querySelector('.spec-table');

      this.buildTable();
    }

    buildTable() {
      // console.log('this.specs', this.specs)
      if (this.specs && this.specs.length && this.tableWrap) {
        const html = this.specs.map(spec => {
          const name = spec['1'];
          const value = spec['2'];
          let content = '';

          // if(name && !value && value !== ''){
          //   content += `<div class="table-heading">${name}</div>`
          // }
          if(name && !value){
            content += `<div class="table-heading">${name}</div>`
          }
          if(name && value){
            content += `<div class="table-content">
              <div class="content_name">${name}</div>
              <div class="content_value">${value}</div>
            </div>`
          }
          return content;
        }).join('');
        this.tableWrap.innerHTML = html;
      } else {
        document.querySelector('.product-spec')?.classList.remove('hidden');
      }
    }
  }

  customElements.define('spec-table', SpecTable);
}
